import ApiHelper from "../helper/ApiHelper";
import Constants from "../helper/Constants";

const ValidateAccount = () => {
  return new Promise((resolve, reject) => {
    const endpoint = "me/account";

    ApiHelper.getRequest(endpoint)
      .then((res) => {
        const { status } = res.data.data;
        const { active } = res.data.data;
        const accActive = active === true;

        const errorObj = {
          mainTitle: Constants.Account.MainErrorMessage.VALIDATE_ACCOUNT_FAILED
        };

        if (!accActive) {
          errorObj.subTitle =
            Constants.Account.SecondaryErrorMessage.ACCOUNT_NOT_ACTIVE;
          reject(errorObj);
        }

        const accStatus = status === 0 || status === 1;

        if (!accStatus) {
          errorObj.subTitle =
            Constants.Account.SecondaryErrorMessage.ACCOUNT_VIOLATED;
          reject(errorObj);
        }

        const accValid = accActive && accStatus;

        if (accValid) {
          resolve(Constants.Account.SuccessMessage.ACCOUNT_VALID);
        }
      })
      .catch((err) => {
        reject(err.response.data.info);
      });
  });
};

export default ValidateAccount;
